export default "__VITE_ASSET__5HYeLV9x__"